import { Moon, Sun } from "lucide-react"
import { cn } from "@/lib/utils"

export type Theme = "light" | "dark"

export interface ThemeToggleProps {
  theme: Theme
  onToggle: () => void
  className?: string
  lightLabel?: string
  darkLabel?: string
}

export function ThemeToggle({
  theme,
  onToggle,
  className,
  lightLabel = "Light mode",
  darkLabel = "Dark mode",
}: ThemeToggleProps) {
  const isDark = theme === "dark"
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={isDark ? lightLabel : darkLabel}
      title={isDark ? lightLabel : darkLabel}
      className={cn(
        "inline-flex items-center justify-center rounded-md h-7 w-7 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors cursor-pointer",
        className,
      )}
    >
      {isDark ? <Sun size={14} strokeWidth={1.75} /> : <Moon size={14} strokeWidth={1.75} />}
    </button>
  )
}
